export enum CardReorderReason {
    LostOrStolen = 0,
    Expired = 1,
    CardNotArrived = 2,
    Replacement = 3,
    ExpiringSoon = 4,
}
